<template>
	<div>
		<a-row :span="10" v-if="!loadingAccounts">
			<filter-card-stories
				@filterDirection="handleDirection"
				@go="handleSearch"
				@mentionFilters="handleMentions"
				@filterDateFrom="HandleFilterDateFrom"
				@filterDateEnd="HandleFilterDateEnd"
				@handleAccountType="handleAccountType"
				:accounts="filterMention"
				v-model="filterMention"
			/>
		</a-row>
		<a-row :span="10" v-if="loadingAccounts">
			<IsLoading :isLoading="loadingAccounts" />
		</a-row>
		<!-- basic search -->
		<a-row type="flex" class="mt-3 mb-3">
			<a-col :span="19">
				<span class="font-weight-bold text-dark font-size-18 text-nowrap"
					>RESULT
				</span>
				<span class="air__utils__link">{{ getStoriesTotalCount }}</span>
				<span class="text-lowercase"> stories matching criteria </span>
			</a-col>
			<a-col :span="5">
				<a-button @click="createCSV" type="default" block>
					Download
				</a-button>
			</a-col>
		</a-row>
		<!-- advance search -->
		<a-row type="flex" align="middle" v-if="showFilter" class="mt-3">
			<a-col :span="24">
				<div class="card air__utils__shadow">
					<div class="card-body">
						<div class="row">
							<div class="col-lg-3">
								<div class="mb-2">
									<div class="text-dark">Desde</div>
									<a-date-picker
										v-model="filterDateFrom"
										format="DD/MM/YYYY"
										:defaultValue="filterDateFrom"
										:disabled-date="disableStartDateBiggerThanEnd"
									/>
								</div>
								<div class="mb-2">
									<div class="text-dark">Hasta</div>
									<a-date-picker
										v-model="filterDateEnd"
										format="DD/MM/YYYY"
										:defaultValue="filterDateEnd"
										:disabled-date="disableDateMoreThanToday"
										@change="handleEndDate"
									/>
								</div>
							</div>
							<div class="col-lg-3">
								<div class="mb-2">
									<div class="text-dark">Mention</div>
									<a-input
										ref="userNameInput"
										v-model="filterMention"
										addon-before="@"
									>
									</a-input>
								</div>
							</div>
						</div>
					</div>
				</div>
			</a-col>
		</a-row>
		<!-- loading storie -->
		<a-row>
			<a-col :span="24">
				<is-loading :isLoading="loadingResults" />
			</a-col>
		</a-row>
		<a-row class="mb-3" v-if="!loadingResults" :gutter="[24, 16]">
			<a-col
				:xs="24"
				:sm="8"
				:md="8"
				:lg="4"
				:order="key"
				v-for="(s, key) in getStories"
				:key="key"
			>
				<a-row>
					<a-col :span="24">
						<a-tooltip placement="bottom">
							<template slot="title">
								<div>
									<div class="d-flex">
										<span class="font-weight-bold mr-1">Mention: </span>
										<span>{{ s.mention }}</span>
									</div>
									<div class="d-flex">
										<span class="font-weight-bold mr-1">Hashtag: </span>
										<span>{{ s.hashtag }}</span>
									</div>
									<div>
										<span>Categorie:</span>
									</div>
								</div>
							</template>
							<div :class="[$style.holder, s.deleted ? $style.deleted : '']">
								<ImageModal :storie="s" />
							</div>
						</a-tooltip>
					</a-col>
				</a-row>
				<div>
					<div class="d-flex">
						<span class="font-weight-bold">Account</span>
						<span class="ml-auto" style="white-space: nowrap;"
							>@{{ s.detailProfileName }}</span
						>
					</div>
					<div class="d-flex flex-wrap">
						<span class="font-weight-bold">Fecha</span>
						<span class="ml-auto">{{
							moment(s.createdAt)
								.utc()
								.format('DD/MM/YYYY')
						}}</span>
					</div>
					<div class="d-flex">
						<span class="font-weight-bold mr-1">Mention </span>
						<span class="ml-auto text-truncate">{{ s.mention }}</span>
					</div>
					<div class="d-flex">
						<span class="font-weight-bold mr-1">Hashtag</span>
						<span class="ml-auto text-truncate">{{ s.hashtag }}</span>
					</div>
					<div class="text-gray-6">
						<div class="mt-3">
							<post-category
								:post="s"
								:categoryA="categoryA"
								:categoryB="categoryB"
							/>
						</div>
					</div>
				</div>
			</a-col>
		</a-row>
		<a-row type="flex" justify="center">
			<a-col v-if="loadingMoreStories">
				<IsLoading :isLoading="loadingMoreStories" />
			</a-col>
			<a-col>
				<div
					v-if="
						!loadingMoreStories &&
							getStoriesTotalCount > createFilter.offset + 24
					"
				>
					<a-button type="link" @click="loadMoreStories">more...</a-button>
				</div>
			</a-col>
		</a-row>
	</div>
</template>

<script>
import IsLoading from '../../widgets/loading'
import ImageModal from '../../widgets/Detail/StorieModal'
import FilterCardStories from '@/components/widgets/Reports/filterCardStories'

import * as ACTIONS from '@/store/actions'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import PostCategory from '@/components/widgets/Post/Categories'

export default {
	name: 'StoriesReport',
	props: {
		categoryA: {
			type: Array,
			required: true,
		},
		categoryB: {
			type: Array,
			required: true,
		},
		accounts: {
			type: Array,
			required: true,
		},
	},
	components: {
		IsLoading,
		ImageModal,
		FilterCardStories,
		PostCategory,
	},
	data: function() {
		return {
			moment,
			showFilter: false,
			filterDateFrom: moment()
				.utc()
				.subtract(20, 'days'),
			filterDateEnd: moment().utc(),
			filterContent: 'all',
			filterOrder: 'date',
			filterMention: [],
			// other
			filterLoading: false,
			loadingAccounts: true,
			loadingResults: false,
			loadingMoreStories: false,
			loadingStorieCount: true,
			filterDirection: 'desc',
			reportData: [],
			offset: 0,
		}
	},
	created() {
		this.getAccounts()
		// .then(() => {
		let filter = this.createFilter
		this.loadingResults = true
		this.loadStories({ filter: filter }).then(res => {
			this.reportData = res
			this.loadingResults = false
		})
		this.countStories({
			where: filter.where,
		}).then(res => {
			this.loadingStorieCount = false
		})
		// })
	},
	methods: {
		getAccounts() {
			this.accounts.map(r => {
				this.filterMention.push(r.ProfileName)
			})
			this.loadingAccounts = false
		},
		createCSV() {
			let reportName =
				'Stories_Report_' +
				this.filterDateFrom.format('YYYY-MM-DD') +
				'_TO_' +
				this.filterDateEnd.format('YYYY-MM-DD')
			let arrData = this.reportData
			let csvFile
			let downloadLink
			let csvContent = []
			let csv = []
			let header = [
				'Account',
				'Account Type',
				'Account Network',
				'Post Identifier',
				'Post Captured',
				'Category A',
				'Category B',
				'Hashtag',
				'Mentions',
			]
			csv.push(header)
			arrData.map(e => {
				let row = []
				row.push(e.detailProfileName || '--')
				row.push(e.accountType || '--')
				row.push(e.networkId === 2 ? 'Instagram' : 'YouTube' || '--')
				row.push(e.code || '--')
				row.push(
					moment(e.createdAt)
						.utc()
						.format('DD/MM/YYYY'),
				)
				row.push(e.categoryAId || '--')
				row.push(e.categoryBId || '--')
				row.push(
					e.hashtag
						? e.hashtag.replace(/\n/g, ' ').replaceAll(',', ' - ')
						: '--',
				)
				row.push(e.mention ? e.mention.replaceAll(',', ' - ') : '--')
				csv.push(row)
			})
			csv.map(row => {
				let rowCsv = row.join(',' + '	')
				csvContent += rowCsv + '\n'
			})
			csvFile = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
			downloadLink = document.createElement('a')
			downloadLink.download = reportName + '.csv'
			downloadLink.href = window.URL.createObjectURL(csvFile)
			downloadLink.style.display = 'none'
			document.body.appendChild(downloadLink)
			downloadLink.click()
		},
		HandleFilterDateFrom(from) {
			this.filterDateFrom = from
		},
		HandleFilterDateEnd(end) {
			if (end > this.filterDateFrom) {
				this.filterDateEnd = end
			}
		},
		handleMentions(evt) {
			this.filterMention = evt
		},
		handleAccountType(evt) {
			this.accountType = evt
		},
		handleFilter() {
			this.showFilter = !this.showFilter
		},
		handleOrder(order) {
			this.filterOrder = order
			this.offset = 0
		},
		handleDirection(dir) {
			this.filterDirection = dir.target.value
			this.offset = 0
		},
		handleSearch(go) {
			if (go === true) {
				let filter = this.createFilter
				this.filterLoading = true
				this.loadingResults = true
				this.offset = 0
				this.loadStories({ filter: filter }).then(res => {
					this.loadingResults = false
					this.filterLoading = false
					this.reportData = res
				})
				this.countStories({
					where: filter.where,
				})
			}
		},
		handleEndDate(evt) {
			if (evt < this.filterDateFrom) {
				this.filterDateEnd = evt
			}
		},
		loadMoreStories() {
			this.offset += 24
			let filter = this.createFilter
			this.loadingMoreStories = true
			this.loadStories({ filter: filter, append: true }).then(res => {
				this.loadingMoreStories = false
			})
		},
		...mapActions({
			loadStories: ACTIONS.STORIES.BY_DETAIL_ID,
			countStories: ACTIONS.STORIES.COUNT,
			loadAccounts: ACTIONS.DASHBOARD.ACCOUNTS,
		}),
	},
	computed: {
		createFilter() {
			let where = {
				and: [{ or: [] }, { createdAt: '' }],
			}
			if (this.filterMention !== null && this.filterMention.length > 0) {
				let mentions = this.filterMention.map(e => {
					return { hashtag: { like: '%' + e + '%' } }
				})
				where.and[0].or = mentions
			}
			where.and[1].createdAt = {
				between: [
					this.filterDateFrom.startOf('day'),
					this.filterDateEnd.endOf('day'),
				],
			}
			let orderBy = 'createdAt'

			if (this.filterOrder === 'date') {
				orderBy = 'createdAt'
			}

			let orderDir = this.filterDirection
			let order = [orderBy + ' ' + orderDir]

			return {
				where: where,
				order: order,
				limit: 24,
				offset: this.offset,
			}
		},

		...mapGetters(['getStories', 'getStoriesTotalCount', 'getCurrentUser']),
	},
}
</script>

<style lang="scss" module>
@import './search.style.module.scss';
</style>
